import { FC } from "react";
import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PageType } from "../../../../config/page.types";
import { useBreadcrumbs } from "../../../../context/BreadcrumbsProvider";

export type ValueChipValue = {
	link?: {
		id?: string;
		url: string;
		pageType: PageType;
	};
	label: string;
	value: string;
	measure: string;
	reqExpand?: boolean;
};

interface Props {
	value: ValueChipValue;
	variant?: "body1" | "h5";
	display?: string;
	flexBasis?: string;
	areFilters?: boolean;
}

const ValueChip: FC<Props> = ({ value, variant = "body1", display = "block", flexBasis = "", areFilters }) => {
	const navigate = useNavigate();
	const { visitPage } = useBreadcrumbs();

	const valueComponent =
		value.link === null || value.link === undefined ? (
			<Typography variant={variant} color="textPrimary">
				{value.value}
			</Typography>
		) : (
			<Button
				variant="text"
				color="primary"
				onClick={() => {
					visitPage(value.link!.pageType, false, value.value, value.link!.id);
					navigate(value.link!.url);
				}}
			>
				{value.value}&nbsp;&gt;
			</Button>
		);

	return (
		<Stack direction="column" flex={`0 0 ${flexBasis}`} display={display} pb={2}>
			<Typography variant="subtitle2" color="textSecondary">
				{value.label}
			</Typography>
			{areFilters && (
				<Typography variant="caption" textTransform={"uppercase"} fontWeight={"700"} color="textPrimary">
					{value.measure}
				</Typography>
			)}
			<Stack alignItems="baseline" direction="row" spacing={0.5}>
				{valueComponent}
				{!areFilters && (
					<Typography variant="caption" color="textSecondary">
						{value.measure}
					</Typography>
				)}
			</Stack>
		</Stack>
	);
};

export default ValueChip;
